import React from 'react';
import { Modal, Input, Form, Select, Icon, DatePicker, Tabs, Button,Spin } from 'antd';
import moment from 'moment';
import auth from '../../../common/utility/auth';
import './styles.css';
import { message } from 'antd';
import { VALE_INGRESO } from '../../../common/types/tipoComprobanteType';
import { INGRESO } from '../../../common/types/tipoMovimientoType';
import { REGISTRADO, ANULADO, IMPORTADO } from '../../../common/types/movimientoEstadoType';
import { FORMAT_NUMBER, FORMAT_3DECIMALS } from '../../../common/types/regularExpresionType';

import File from "./File";
import global from '../../../common/utility/global';
const InputGroup = Input.Group;
const { Search } = Input;
const { Option } = Select;
const { TabPane } = Tabs;



class FormModal extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
        }
    }


    handleChangeFile = async (event) => {
        var file = event.target.files[0];
        if (!file) return;

        var fileExtension = file.name.split(".")[1];
        var fileSize = Math.floor(file.size / 1024);
        var allowedExtensions = ["xlsx"];

        if (
            allowedExtensions.filter((m) => {
                return m === fileExtension;
            }).length === 0
        ) {
            message.error(
                "Solo puede subir archivos: " + allowedExtensions.join(" / ") + "."
            );
            return;
        }

        if (fileSize > 5120) {
            message.error(
                "Tamaño máximo permitido " +
                parseFloat(parseFloat(fileSize / 1024).toFixed(2)).toString() +
                " mb."
            );
            return;
        }


        this.props.form.setFieldsValue({
            nombreArchivo: file.name,
            icon: "loading",
        });

        var response = await this.props.onUploadFile(file);

        if (response.status !== 200) {
            message.error("Ocurrió un error al intentar subir el archivo.");
            this.handleRemoveFile();
            return;
        }

        this.props.form.setFieldsValue({
            icon: "folder-open",
            url: response.data.url
        });
    };

    handleRemoveFile = () => {
        global.cleanInputFile(
            this.props.form.getFieldValue("identifier"),
            this.handleChangeFile
        );
        this.props.form.setFieldsValue({
            url: "",
            nombreArchivo: "",
            listaCargaMasiva: [],
            icon: "folder-open",
        });
    };

    handleCancel = () => {
        this.props.onClose();
        this.props.form.resetFields();
    };


    findDaysAndDates = (property, value) => {
        if (property === 'fechaStr') {

            console.log('cambio 2');
            const fecha = moment(value, 'DD/MM/YYYY');
            const minFecha = fecha.format('YYYY/MM/DD');

            const gridProductos = this.props.form.getFieldValue('arrDetalle');
            const detalleProductos = this.props.formValues.listaComprobanteDetalle;
            for (var i = 0; i < detalleProductos.length; i++) {
                debugger
                var obj_current_data = gridProductos.filter(m => { return m.idProducto == detalleProductos[i].idProducto; })[0];

                detalleProductos[i].fechaVencimiento = moment(value, 'DD/MM/YYYY').format('DD/MM/YYYY');
                detalleProductos[i].fechaProduccion = moment(value, 'DD/MM/YYYY').format('DD/MM/YYYY');
                detalleProductos[i].flagAfecto = obj_current_data.flagAfecto;
                detalleProductos[i].precioUnitario = obj_current_data.precioUnitario;
                detalleProductos[i].cantidad = obj_current_data.cantidad;
                detalleProductos[i].subTotal = obj_current_data.subTotal;
                detalleProductos[i].igv = obj_current_data.igv;
                detalleProductos[i].total = obj_current_data.total;
                detalleProductos[i].lote = obj_current_data.lote;
                detalleProductos[i].numeroRegistroSanitario = obj_current_data.numeroRegistroSanitario;
                detalleProductos[i].minFechaStr = minFecha;
            }

            this.props.form.setFieldsValue({ listaComprobanteDetalle: detalleProductos });
        }
    }

    handleCompleteDecimals = (property, value) => {
        if (value === '' || isNaN(parseFloat(value).toFixed(3)))
            this.props.form.setFieldsValue({ [property]: '0.000' });
        else
            this.props.form.setFieldsValue({ [property]: parseFloat(value).toFixed(3) });
    }

    handleCancel = () => {
        this.props.onClose();
        this.props.form.resetFields();
    };


    handleOk = (e) => {
        e.preventDefault();
        this.props.form.validateFieldsAndScroll((err, values) => {
            console.log(values);
            if (!err) {

                var params = auth.user().parametros;
                var porcentajeIGV = 18;

                const form = {
                    "id": values.id,
                    "idTipoMovimiento": INGRESO.ID,
                    "idEntidad": values.idEntidad,
                    "idConcepto": values.idConcepto.key,
                    "idAlmacen": values.idAlmacen.key,
                    "idMoneda": values.idMoneda.key,
                    "orden": 1,
                    "idTipoComprobante": VALE_INGRESO.ID,
                    "serie": "I001",
                    "documento": null,
                    "fecha": null,
                    "fechaStr": values.fechaStr.format('DD/MM/YYYY'),
                    "tipoCambio": parseFloat(values.tipoCambio),
                    "porcentajeIGV": porcentajeIGV,
                    "subTotal": values.sumaSubTotal,
                    "igv": values.sumaIgv,
                    "total": values.sumaTotal,
                    "peso": null,
                    "observacion": values.observacion,
                    "fechaActivacion": null,
                    "idMovimientoEstado": REGISTRADO,
                    "url": values.url,
                    "idProyecto": values.idProyecto === undefined ? 0 : values.idProyecto.key
                }

                if (values.url === undefined || values.url === "") {
                    message.warning('Debe seleccionar el formato de carga .');
                    return;
                }

                this.props.onSave(form, this.props.form);
            }
        });
    }

    render() {
        const { getFieldDecorator, setFieldsValue, getFieldValue } = this.props.form;

        getFieldDecorator('id', { initialValue: this.props.formValues.id });

        getFieldDecorator('sumaSubTotal', { initialValue: this.props.formValues.sumaSubTotal });
        getFieldDecorator('sumaIgv', { initialValue: this.props.formValues.sumaIgv });
        getFieldDecorator('sumaTotal', { initialValue: this.props.formValues.sumaTotal });

        getFieldDecorator("identifier", { initialValue: "file-carga-masiva" });
        getFieldDecorator("url", { initialValue: this.props.formValues.urlCargaMasiva });
        getFieldDecorator("nombreArchivo", {
            initialValue: this.props.formValues.nombreArchivo,
        });
        getFieldDecorator("icon", { initialValue: "folder-open" });
        return (
            <Modal
                title={(<div>Registrar Ingresos</div>)}
                visible={this.props.visible}
                style={{ top: 30 }}
                cancelText={"Cancelar"}
                okText={"Guardar"}
                onCancel={this.handleCancel}
                onOk={this.handleOk}
                width="1100px"
            >
                <Form>
                    {getFieldDecorator('id', { initialValue: this.props.formValues.id })(
                        <input type="hidden" />
                    )}

                    {getFieldDecorator('idOrdenCompra', { initialValue: this.props.formValues.idOrdenCompra })(
                        <input type="hidden" />
                    )}

                    <div className="row">
                        <div className="col-md-4 form-group">
                            <Form.Item label="Fecha / Tipo de Cambio">
                                <InputGroup compact>
                                    <Form.Item style={{ width: '65%' }}>
                                        {getFieldDecorator('fechaStr', {
                                            initialValue: moment(this.props.formValues.fechaStr, 'DD/MM/YYYY'),
                                            rules: [{
                                                type: 'object',
                                                required: true,
                                                message: 'Requerido'
                                            }],
                                        })(
                                            <DatePicker
                                                disabled={true}
                                                className="first-input"
                                                placeholder="Seleccione fecha"
                                                prefix={<Icon type="filter" style={{ color: 'rgba(0,0,0,.25)' }} />}
                                                format="DD/MM/YYYY"
                                                onChange={
                                                    (moment, value) => {
                                                        this.props.onChange('fechaStr', value);
                                                        this.findDaysAndDates('fechaStr', value);
                                                    }
                                                }
                                            />
                                        )}
                                    </Form.Item>
                                    <Form.Item style={{ width: '35%' }}>
                                        {getFieldDecorator('tipoCambio', {
                                            initialValue: parseFloat(this.props.formValues.tipoCambio).toFixed(3),
                                            rules: [{
                                                required: true,
                                                pattern: new RegExp(FORMAT_3DECIMALS),
                                                message: "Formato decimal incorrecto (0.000)"
                                            }]
                                        })(
                                            <Input
                                                className="text-right second-input"
                                                placeholder="Ingresar Tipo de Cambio"
                                                autoComplete="off"
                                                onBlur={(e) => this.handleCompleteDecimals("tipoCambio", e.target.value)}
                                            />
                                        )}
                                    </Form.Item>

                                </InputGroup>
                            </Form.Item>
                        </div>
                        <div className="col-md-4 form-group">
                            <Form.Item label="Serie / Documento">
                                <InputGroup compact>
                                    <Form.Item style={{ width: '40%' }}>
                                        {getFieldDecorator('serie', {
                                            initialValue: this.props.formValues.serie
                                        })(
                                            <Input
                                                placeholder="Serie"
                                                autoComplete="off"
                                                className="first-input"
                                                disabled={true}
                                            />
                                        )}
                                    </Form.Item>
                                    <Form.Item style={{ width: '60%' }}>
                                        {getFieldDecorator('documento', {
                                            initialValue: this.props.formValues.documento
                                        })(
                                            <Input
                                                placeholder="Documento"
                                                autoComplete="off"
                                                className="second-input"
                                                disabled={true}
                                            />
                                        )}
                                    </Form.Item>
                                </InputGroup>
                            </Form.Item>
                        </div>
                        <div className="col-md-4 form-group">
                            <Form.Item label="Moneda">
                                {getFieldDecorator('idMoneda', {
                                    initialValue: this.props.formValues.idMoneda ?
                                        { key: this.props.formValues.idMoneda } : undefined,
                                    rules: [{
                                        required: true,
                                        message: 'Campo obligatorio.',
                                    }]
                                })(
                                    <Select showSearch labelInValue
                                        placeholder={"Seleccione Moneda"}
                                        optionFilterProp="children"
                                        onChange={(option) => this.props.onChange('idMoneda', option.key)}
                                    >
                                        {this.props.formValues.monedas.map(item => (
                                            <Option key={item.id} value={item.id}>{item.nombre}</Option>
                                        ))}
                                    </Select>
                                )}
                            </Form.Item>
                        </div>
                    </div>

                    <div className="row">
                        <div className="col-md-8 form-group">
                            <Form.Item label="Entidad">
                                <InputGroup compact>
                                    <Form.Item style={{ width: '100%' }}>
                                        {getFieldDecorator('idEntidad', {
                                            initialValue: this.props.formValues.idEntidad || undefined,
                                            rules: [{
                                                required: true,
                                                message: 'Campo obligatorio.',
                                            }]
                                        })(
                                            <Select
                                                showSearch
                                                placeholder="Seleccione Entidad"
                                                optionFilterProp="children"
                                                className="second-input"
                                                notFoundContent={this.props.fetching ? <Spin size="small" /> : null}
                                                filterOption={false}

                                                onSearch={this.props.fetchClientes}
                                                onSelect={(value, option) => {
                                                    this.props.onChangeEntidad(value, this.props.form)
                                                }}
                                            >
                                                {this.props.formValues.entidades.map(item => (
                                                    <Option key={item.id} value={item.id}>
                                                        {item.razonSocial + ' - ' + item.tipoDocumento + ' - ' + item.numeroDocumento}
                                                    </Option>
                                                ))}
                                            </Select>
                                        )}
                                    </Form.Item>

                                </InputGroup>
                            </Form.Item>
                        </div>
                        <div className="col-md-4 form-group">
                            <Form.Item label="Concepto">
                                {getFieldDecorator('idConcepto', {
                                    initialValue: this.props.formValues.idConcepto ?
                                        { key: this.props.formValues.idConcepto } : undefined,
                                    rules: [{
                                        required: true,
                                        message: 'Campo obligatorio.',
                                    }]
                                })(
                                    <Select showSearch labelInValue
                                        placeholder={"Seleccione Concepto"}
                                        optionFilterProp="children"
                                        onChange={(option) => {
                                            this.props.onChange("idConcepto", option.key)
                                        }}
                                    >
                                        {this.props.formValues.conceptos.map(item => (
                                            <Option key={item.id} value={item.id}>{item.nombre}</Option>
                                        ))}
                                    </Select>
                                )}
                            </Form.Item>
                        </div>

                    </div>

                    <div className="row">


                        <div className="col-md-4 form-group">
                            <Form.Item label="Establecimiento">
                                {getFieldDecorator('idEstablecimiento', {
                                    initialValue: this.props.formValues.idEstablecimiento ?
                                        { key: this.props.formValues.idEstablecimiento } : undefined,
                                    rules: [{
                                        required: true,
                                        message: 'Campo obligatorio.',
                                    }]
                                })(
                                    <Select showSearch labelInValue
                                        placeholder={"Seleccione Establecimiento"}
                                        optionFilterProp="children"
                                        onChange={(option) => {
                                            this.props.form.setFieldsValue({ idAlmacen: undefined });
                                            this.props.onChange("idEstablecimiento", option.key)
                                        }}
                                    >
                                        {this.props.formValues.establecimientos.map(item => (
                                            <Option key={item.id} value={item.id}>{item.nombre}</Option>
                                        ))}
                                    </Select>
                                )}
                            </Form.Item>
                        </div>
                        <div className="col-md-4 form-group">
                            <Form.Item label="Almacén">
                                {getFieldDecorator('idAlmacen', {
                                    initialValue: this.props.formValues.idAlmacen ?
                                        { key: this.props.formValues.idAlmacen } : undefined,
                                    rules: [{
                                        required: true,
                                        message: 'Campo obligatorio.',
                                    }]
                                })(
                                    <Select showSearch labelInValue
                                        placeholder={"Seleccione Almacén"}
                                        optionFilterProp="children"
                                        loading={this.props.formValues.almacenLoading}
                                    >
                                        {this.props.formValues.almacenes.map(item => (
                                            <Option key={item.id} value={item.id}>{item.nombre}</Option>
                                        ))}
                                    </Select>
                                )}
                            </Form.Item>
                        </div>
                        <div className="col-md-4 form-group">
                            <Form.Item label="Proyecto">
                                {getFieldDecorator('idProyecto', {
                                    initialValue: this.props.formValues.idProyecto ?
                                        { key: this.props.formValues.idProyecto } : undefined
                                })(
                                    <Select showSearch labelInValue
                                        placeholder={"Seleccione Proyecto"}
                                        optionFilterProp="children"
                                        onChange={(option) => this.props.onChange('idProyecto', option.key)}
                                    >
                                        {this.props.formValues.proyectos.map(item => (
                                            <Option key={item.id} value={item.id}>{item.nombre}</Option>
                                        ))}
                                    </Select>
                                )}
                            </Form.Item>
                        </div>

                    </div>

                    <div className="row">
                        <div className="col-md-12 form-group">
                            <Form.Item label="Observación">
                                {getFieldDecorator('observacion', {
                                    initialValue: this.props.formValues.observacion
                                })(
                                    <Input
                                        placeholder="Ingresar Observación"
                                        autoComplete="off"
                                    />
                                )}
                            </Form.Item>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-md-6 form-group">
                            <Button
                                icon="file-excel"
                                type="primary"
                                onClick={this.props.onDownloadFormatoCargaMasiva}
                            >
                                Descargar Formato Carga Masiva
                            </Button>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-md-12 form-group">
                            <Form.Item label="Seleccionar Formato de Carga">
                                <File
                                    identifier={getFieldValue('identifier')}
                                    filename={getFieldValue('nombreArchivo')}
                                    downloadUrl={getFieldValue('url')}
                                    icon={getFieldValue('icon')}
                                    onChange={this.handleChangeFile}
                                    onRemove={this.handleRemoveFile}
                                />
                            </Form.Item>
                        </div>
                    </div>

                    {/* <TotalDetalle
                        formValues={this.props.formValues}
                        onGetFieldDecorator={getFieldDecorator}
                        onGetFieldValue={getFieldValue}
                    /> */}

                </Form>
            </Modal>
        )
    }
}
export default Form.create()(FormModal)